
export enum UsesType {
    None,
    Residential,
    Lodging,
    Office,
    Commercial,
    Civic,
    CivicSupport,
    Educational,
    Industrial,
    Agricultural
}

const usesTypesNames = [
    'None',
    'Residential',
    'Lodging',
    'Office',
    'Commercial',
    'Civic',
    'Civic Support',
    'Educational',
    'Industrial',
    'Agricultural'
];

export function getUsesTypesNames(): string[] {
    return usesTypesNames.slice(1);
}

export function getUseTypeByName(name: string) {
    return usesTypesNames.indexOf(name);
}
